import { render, staticRenderFns } from "./SelectCompanyInput.vue?vue&type=template&id=af80640e&"
import script from "./SelectCompanyInput.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports